define('OutSystems/ReactWidgets/Image',["require", "exports", "tslib", "OutSystems/ClientRuntime/ApplicationInfo", "OutSystems/ClientRuntime/Settings", "OutSystems/ReactView/HtmlTags", "OutSystems/ReactView/Widget", "react"], function (require, exports, tslib_1, ApplicationInfo, Settings_1, HtmlTags_1, Widget_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Image = exports.ImageCache = void 0;
    var ImageCache;
    (function (ImageCache) {
        ImageCache.TTL = 2 * 60 * 1000;
        ImageCache.GC_INTERVAL = 10 * 1000;
        ImageCache.GC_HIGH_PRESSURE = 50 * 1024 * 1024;
        ImageCache.map = new Map();
        function gc() {
            var now = Date.now();
            var underPressure = ImageCache.GC_HIGH_PRESSURE < cacheSize;
            ImageCache.map.forEach(function (cached, key, map) {
                if (cached.referenceCount <= 0 && (underPressure || cached.expireDate < now)) {
                    URL.revokeObjectURL(cached.cachedObjectURL);
                    map.delete(key);
                    cacheSize -= cached.size;
                }
            });
        }
        ImageCache.gc = gc;
        ImageCache.intervalFunction = function () { return ((0, Settings_1.getEnvParams)().EnforceUnsafeEval ? undefined : ImageCache.gc); };
        ImageCache.interval = setInterval(ImageCache.intervalFunction(), ImageCache.GC_INTERVAL);
        var cacheSize = 0;
        function releaseURL(imageBinary) {
            var key = imageBinary.content;
            var element = ImageCache.map.get(key);
            if (element !== undefined) {
                element.referenceCount--;
                element.expireDate = Date.now() + ImageCache.TTL;
                ImageCache.map.set(key, element);
                if (ImageCache.GC_HIGH_PRESSURE < cacheSize) {
                    gc();
                }
            }
        }
        ImageCache.releaseURL = releaseURL;
        function requestURL(imageBinary) {
            var key = imageBinary.content;
            var element = ImageCache.map.get(key);
            if (!key) {
                return null;
            }
            if (element === undefined) {
                var imageBlob = imageBinary.toBlob();
                if (!imageBlob) {
                    return null;
                }
                element = {
                    expireDate: 0,
                    referenceCount: 0,
                    cachedObjectURL: URL.createObjectURL(imageBlob),
                    size: imageBlob.size,
                };
                cacheSize += element.size;
            }
            element.referenceCount++;
            ImageCache.map.set(key, element);
            return element.cachedObjectURL;
        }
        ImageCache.requestURL = requestURL;
    })(ImageCache || (exports.ImageCache = ImageCache = {}));
    var Image = (function (_super) {
        tslib_1.__extends(Image, _super);
        function Image(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.state = {
                objectURL: null,
                hasError: false,
            };
            return _this;
        }
        Image_1 = Image;
        Image.prototype.loadBinary = function (loadingBinary) {
            var _this = this;
            var cachedContent = this.props.imageContent.content;
            loadingBinary.loadContent().then(function (imageBinary) {
                var content = imageBinary.content;
                if (!_this.state.objectURL || content !== cachedContent) {
                    var objectURL = ImageCache.requestURL(loadingBinary);
                    _this.setState({
                        objectURL: objectURL,
                        hasError: false,
                    });
                }
            });
        };
        Image.prototype.UNSAFE_componentWillMount = function () {
            if (Image_1.isBinary(this.props)) {
                this.loadBinary(this.props.imageContent);
            }
        };
        Image.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
            if (Image_1.isBinary(nextProps)) {
                if (!nextProps.imageContent.fastEquals(this.props.imageContent)) {
                    ImageCache.releaseURL(this.props.imageContent);
                    this.loadBinary(nextProps.imageContent);
                }
            }
            else {
                this.setState({
                    hasError: false,
                });
            }
        };
        Image.isBinary = function (props) {
            return props.type === 2 && props.imageContent && !props.imageContent.url;
        };
        Image.prototype.componentWillUnmount = function () {
            if (Image_1.isBinary(this.props)) {
                ImageCache.releaseURL(this.props.imageContent);
            }
        };
        Image.getBinaryImgAbsoluteURL = function (url) {
            if (!url) {
                return url;
            }
            var r = new RegExp("^(blob:)?(?:[a-z]+:)?//|^/", "i");
            if (r.test(url)) {
                return url;
            }
            else {
                return "/".concat(ApplicationInfo.getBasePath(), "/").concat(url).replace(new RegExp("/(/)+", "g"), "/");
            }
        };
        Image.prototype.prepareImageAttributes = function () {
            var _this = this;
            var imageAttributes = {
                "data-image": "",
                className: this.props.style,
                src: "",
            };
            if (this.state.hasError) {
                imageAttributes.src = Image_1.getBinaryImgAbsoluteURL(this.props.defaultImage);
            }
            else {
                switch (this.props.type) {
                    case 1:
                        imageAttributes.src = this.props.url;
                        break;
                    case 2:
                        if (this.state.objectURL) {
                            imageAttributes.src = this.state.objectURL;
                        }
                        else {
                            if (this.props.imageContent && this.props.imageContent.hasContent()) {
                                imageAttributes.src = Image_1.getBinaryImgAbsoluteURL(this.props.imageContent.url);
                            }
                            else {
                                imageAttributes.src = Image_1.getBinaryImgAbsoluteURL(this.props.defaultImage);
                            }
                        }
                        break;
                    default:
                        imageAttributes.src = this.props.image;
                        break;
                }
                imageAttributes.onError = function () {
                    if (_this.props.defaultImage) {
                        _this.setState({
                            hasError: true,
                        });
                    }
                };
            }
            this.fillWithBuiltinProperties(imageAttributes);
            return imageAttributes;
        };
        Image.prototype.render = function () {
            return React.createElement(HtmlTags_1.HtmlTags.img, this.prepareImageAttributes());
        };
        var Image_1;
        Image = Image_1 = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], Image);
        return Image;
    }(Widget_1.Widget));
    exports.Image = Image;
});
//# sourceMappingURL=Image.js.map;
